import { AddressParam } from "@stripe/stripe-js";

export const PERFECT_FIT = "Perfect fit";
export const POPULAR_SIZES = "Popular sizes";
export const AVAILABLE_SIZES = "Available sizes";
export const CUSTOM_SIZE = "Custom";
export const TWO_BY_THREE = "2:3 Ratio";
export const SQUARE = "Square";
export const CLASSIC = "Classic";
export const HDALU = "HD Aluminum";
export const NY_SALES_TAX_RATE = 0.08875;

export const IS_INTERNAL = window.location.hostname.includes("internal");
export const TRIBECA_ADDRESS = {
  name: "Tribeca Printworks",
  address: {
    line1: "333 Hudson St",
    line2: "rm 201",
    city: "New York",
    state: "NY",
    postal_code: "10013",
    country: "US",
  } satisfies Required<AddressParam>,
  text: "Business days / from 9:00am - 10pm",
};
